import { QueueState, queueStore } from '@/scopes/checkout/groups/infrastructure/store/queueStore'
import { identity } from 'ramda'
import { useStore } from 'zustand'

export function useQueueStore(
  selector: (state: QueueState) => any,
) {
  const store = useStore(queueStore, identity<QueueState>)
  return selector(store)
}
